<template>
  <b-modal ref="mdlConfigurazioneTabellaIva" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg" @ok="onOkMdlContabilitaIva" @show="onShow">
    <b-row>
      <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
        <label class="sa-label-data">Codice Iva</label>
        <span v-if="isReadOnly"> {{ jsonData.codiceIva }}</span>
        <b-form-input v-else v-model="jsonData.codiceIva"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
        <label class="sa-label-data">Descrizione Iva</label>
        <span v-if="isReadOnly"> {{ jsonData.descrizioneIva }}</span>
        <b-form-input v-else v-model="jsonData.descrizioneIva"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
        <label class="sa-label-data">Aliquota Iva</label>
        <span v-if="isReadOnly"> {{ jsonData.aliquotaIva }}</span>
        <b-form-input type="number" min="0" max="100" step="10" v-else v-model="jsonData.aliquotaIva"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
        <label class="sa-label-data">Marca Bollo</label>
        <span v-if="isReadOnly"> {{ jsonData.marcaBollo }}</span>
        <b-form-select v-else v-model="jsonData.marcaBollo" :options="marcaBolloOptions" text-field="text" value-field="value">
          <template #first>
            <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
        <label class="sa-label-data">Marca Bollo Importo</label>
        <span v-if="isReadOnly"> {{ jsonData.marcaBolloImporto }}</span>
        <b-form-input v-else v-model="jsonData.marcaBolloImporto" type="number" min="0" step="0.1"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
        <label class="sa-label-data">Marca Bollo Importo Minimo </label>
        <span v-if="isReadOnly"> {{ jsonData.marcaBolloImportoMinimo }}</span>
        <b-form-input v-else v-model="jsonData.marcaBolloImportoMinimo" type="number" min="0" step="0.1"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
        <label class="sa-label-data">Natura Codice </label>
        <span v-if="isReadOnly"> {{ jsonData.naturaCodice }}</span>
        <b-form-input v-else v-model="jsonData.naturaCodice"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
        <label class="sa-label-data">Natura Descrizione </label>
        <span v-if="isReadOnly"> {{ jsonData.naturaDescrizione }}</span>
        <b-form-input v-else v-model="jsonData.naturaDescrizione"></b-form-input>
      </b-col>
    </b-row>
    <!-- <template #modal-footer>
			<b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
			<b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaDocumento">Salva</b-button>
			<b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
		</template> -->
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin],
  components: { ModalError },
  data() {
    return {
      title: null,
      pathResource: "/contabilitatabellaiva",
      isReadOnly: false,
      jsonData: {
        codiceIva: null,
        descrizioneIva: null,
        aliquotaIva: 0.0,
        marcaBollo: null,
        marcaBolloImporto: 0.0,
        marcaBolloImportoMinimo: 0.0,
        naturaCodice: null,
        naturaDescrizione: null,
      },
      marcaBolloOptions: [
        { text: "NO", value: "NO" },
        { text: "SI", value: "SI" },
      ],
    };
  },
  mounted() {},
  methods: {
    //=================READ===================
    show(jsonData) {
      let me = this;
      this.title = "Nuova Iva";
      if (jsonData.id) {
        this.title = "Modifica Iva";
        this.jsonData = JSON.parse(JSON.stringify(jsonData));
        this.jsonData.aliquotaIva = this.jsonData.aliquotaIva * 100;
      } else {
        this.resetJsonDataIva();
      }
      me.$refs.mdlConfigurazioneTabellaIva.show();
    },
    onCloseModal() {
      let me = this;
      me.jsonData = {};
      me.$emit("onCloseModal");
      me.$refs.mdlConfigurazioneTabellaIva.hide();
    },
    onInputTipoDocumento(input) {
      console.log(input);
      let documentoTipo = this.contabilitaTipoDocumentoOptions.filter((e) => e.codiceTipoDocumento == input);
      if (documentoTipo[0]) {
        let docTipo = documentoTipo[0];
        this.jsonData.descrizioneTipoDocumento = docTipo.descrizioneTipoDocumento;
        this.jsonData.idTipoDocumento = docTipo.id;
      }
    },

    resetJsonDataIva() {
      this.jsonData = {
        id: null,
        codiceIva: null,
        descrizioneIva: null,
        aliquotaIva: 0.0,
        marcaBollo: null,
        marcaBolloImporto: 0.0,
        marcaBolloImportoMinimo: 0.0,
        naturaCodice: null,
        naturaDescrizione: null,
      };
    },

    salvaDocumentoCausaleSuccess(response) {
      let me = this;
      response;
      me.$refs.mdlConfigurazioneTabellaIva.hide();
      me.$bvToast.toast("Salvataggio avvenuto con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    salvaDocumentoCausaleError(error) {
      let me = this;
      me.$emit("saveDocumentoArticolo", error);
      me.$refs.cmpModalError.show(error.response.data.messaggio);
    },
    validazione() {
      let esito = true;
      let msg = "";

      if (this.jsonData.codiceIva == null || this.jsonData.codiceIva.trim() == "") {
        msg += "Codice Iva  non valido ! #";
        esito = false;
      }
      if (this.jsonData.descrizioneIva == null || this.jsonData.descrizioneIva.trim() == "") {
        msg += "Descrizione Iva  non valida ! #";
        esito = false;
      }
      if (this.jsonData.aliquotaIva == null || this.jsonData.aliquotaIva < 0) {
        msg += "Aliquota Iva  non valida ! #";
        esito = false;
      }
      if (this.jsonData.marcaBollo == null) {
        msg += "Marca Bollo Iva  non valida ! #";
        esito = false;
      } else {
        if ("SI".includes(this.jsonData.marcaBollo)) {
          if (this.jsonData.marcaBolloImporto == null || this.jsonData.marcaBolloImporto < 0) {
            msg += "Marca Bollo Si,   Indicare importo o importo non valido #";
            esito = false;
          }
          if (this.jsonData.marcaBolloImportoMinimo == null || this.jsonData.marcaBolloImporto < 0) {
            msg += "Marca Bollo Si,   Indicare importo minimo o importo minimo non valido #";
            esito = false;
          }
        }
      }

      return { esito: esito, msg: msg };
    },
    generaBtoast(validation) {
      let message = validation.msg.split("#");
      const h = this.$createElement;
      const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
      message.forEach((element) => {
        if (element.trim() != "") {
          vNodesMsg.children.push({ tag: "li", text: element });
        }
      });
      this.$bvToast.toast([vNodesMsg], {
        title: "Attenzione!",
        autoHideDelay: 5000,
        variant: "danger",
      });
    },
    contabilitaTipoDocumentoLoadDataSuccess(response) {
      this.tipoDocumentoOptions = response.data.data;
      console.log(this.tipoDocumentoOptions);
    },
    onShow() {},
    onOkMdlContabilitaIva(bvModalEvent) {
      let me = this;
      bvModalEvent.preventDefault();
      let validation = me.validazione();
      if (!validation.esito) {
        me.generaBtoast(validation);
        return;
      }
      this.jsonData.aliquotaIva = new Number(this.jsonData.aliquotaIva / 100);
      this.openShowModalLoading();
      this.$emit("beforeSave");
      this.saveResource(me.pathResource, me.jsonData, me.saveResourceSuccess, me.saveResourceError); //, me.saveResourceError
    },
    saveResourceSuccess() {
      this.$refs.mdlConfigurazioneTabellaIva.hide();
      this.$emit("afterSave");
      this.closeShowModalLoading();
    },
    saveResourceError(error) {
      let message = error.response.data.messaggio;
      this.errorToast(message);
    },
  },
};
</script>
